import { Reveal } from "@/components/site/motion";
import { Loader2 } from "lucide-react";

const ITEMS = [
  "AI qualification recognition (UK & international)",
  "Automatic eligibility checking",
  "University portal",
  "Student portal",
  "Interview scheduling",
  "WhatsApp integration",
  "Secure document vault",
  "University API integrations",
  "Automated application submission",
  "Real-time application tracking",
  "Multilingual platform",
  "Analytics dashboard",
  "Student Finance guidance",
  "AI assistant",
];

export const Roadmap = () => (
  <section id="roadmap" data-testid="roadmap-section" className="relative py-28 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="max-w-2xl">
        <Reveal><p className="text-xs uppercase tracking-[0.22em] text-cobalt font-semibold">Technology Roadmap</p></Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-5 font-display font-extrabold tracking-tighter text-ink text-4xl sm:text-5xl leading-[0.98]">
            Coming During Development
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 text-lg leading-relaxed text-slatey">
            The capabilities we're actively building ahead of launch. Each is currently in development.
          </p>
        </Reveal>
      </div>

      <div className="relative mt-14">
        <div className="absolute left-[7px] top-2 bottom-2 w-px bg-slate-200 md:hidden" />
        <div className="grid gap-3 md:grid-cols-2">
          {ITEMS.map((item, i) => (
            <Reveal
              key={i}
              delay={(i % 2) * 0.05}
              className="group relative flex items-center gap-4 rounded-2xl border border-slate-200 bg-white p-4 pl-5 transition-colors duration-200 hover:border-cobalt/30"
              data-testid={`roadmap-item-${i}`}
            >
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-cobalt/10 font-display text-xs font-bold text-cobalt">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="flex-1 text-[15px] font-medium text-ink">{item}</span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-amber-50 px-2.5 py-1 text-[11px] font-semibold text-amber-600">
                <Loader2 className="h-3 w-3 animate-spin" />
                In Development
              </span>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
